module.exports = __webpack_public_path__ + "media/images/logo-606bd0de181ffb84628ff14900b47ef1.png";